import { ErrorMessage } from "@hookform/error-message";
import { useFormContext } from "react-hook-form";
import { PatternFormat } from "react-number-format";

const TelField = ({
	registeredName,
	label,
	isRequired,
	requiredText,
	placeholder,
	defaultValue,
	disabled,
}: {
	registeredName: string;
	label: string;
	isRequired: boolean;
	requiredText: string;
	placeholder: string;
	defaultValue?: string;
	disabled?: boolean;
}) => {
	const {
		register,
		setValue,
		formState: { errors },
	} = useFormContext();

	register(registeredName, {
		validate: (value) => {
			if (isRequired && (!value || value.length < 10)) {
				return requiredText;
			}
		},
	});

	const disabledClass = disabled ? " bg-gray-200 border-gray-400" : "";
	const cssClass =
		"border border-black w-full py-3 px-2 placeholder:uppercase" +
		disabledClass;

	return (
		<div className="mb-3">
			<label
				className="ml-2 block text-sm uppercase"
				htmlFor={`input-${registeredName}`}
			>
				{label}
				{isRequired && "*"}
			</label>

			<ErrorMessage
				errors={errors}
				name={registeredName}
				render={({ message }) => (
					<p className="mb-1 ml-2 text-xs text-red-500">{message}</p>
				)}
			/>

			<PatternFormat
				format="###-###-####"
				mask="_"
				id={`input-${registeredName}`}
				placeholder={placeholder}
				defaultValue={defaultValue || ""}
				onValueChange={(values) => {
					setValue(registeredName, values.value);
				}}
				className={cssClass}
				disabled={disabled}
				required={isRequired}
			/>
		</div>
	);
};
export default TelField;
